'use strict';

angular.module('amexReconciliationApp')
  .directive('transactionRow', function () {
    return {
      templateUrl: 'scripts/views/directives/transaction-row.html',
      scope: {},
      bindToController: {
        transaction: '<',
        headers: '<',
        transactionIndex: '<',
        firstSchema: '<',
        secondSchema: '<',
        showReceiptIcon: '&',
        showLinkIcon: '&'
      },
      controllerAs: 'transactionRowController',
      controller: function TransactionRowController($scope,
                                                    SelectedTransactionService,
                                                    $translate,
                                                    SiteConfigModel,
                                                    TransactionFieldModel,
                                                    MerchantInfoRepository,
                                                    UserModel,
                                                    AdditionalTransactionDataRepository) {
        var self = this;
        self.isChecked = SelectedTransactionService.isSelected;
        self.isBtaProductType = SiteConfigModel.isBtaProductType;
        self.isPo = SiteConfigModel.isPo;
        self.approvalSettingOnForSite = SiteConfigModel.approvalSettingOnForSite;
        self.exceptionCodes = {};
        self.exceptionNote = getExceptionNote();
        self.isNumber = TransactionFieldModel.isNumber;
        self.displayCustomizableColumn = SiteConfigModel.displayCustomizableColumn;
        self.customizedFields = TransactionFieldModel.getFields();
        self.isFieldSelected = function isFieldColumnSelected(fieldName) { return SiteConfigModel.isColoumnSelected(fieldName);};
        self.valueForGivenField = function (fieldName) {
          return TransactionFieldModel.getGivenFieldValue(fieldName,self.transaction);
        };
        self.merchantInfo = null;
        self.comments = null;

        self.$onChanges = function (changes) {
          if (changes.transaction) {
            var transaction = changes.transaction.currentValue;
            self.reviewed = hasBeenReviewed(transaction);
            self.hasException = _.get(transaction, 'details.exceptionFlag', false);
          }
        };

        self.valueForDropdownField = function () {
          return TransactionFieldModel.getFieldValue(self.transaction);
        };

        self.hasComments = function() {
          var commentIndicator = _.get(self.transaction, 'mutableTransactionProperties.commentIndicator');
          return commentIndicator && commentIndicator !== 'NO_COMMENT';
        };

        self.getCommentsColor = function() {
          var commentIndicator = _.get(self.transaction, 'mutableTransactionProperties.commentIndicator');

          switch(commentIndicator) {
            case 'CARDMEMBER_COMMENT':
              return 'warning-font';
            case 'MANAGER_COMMENT':
              return 'type-amex-blue';
            case 'BOTH':
              return 'success-font';
            default:
              return '';
          }
        };

        self.getCommentsToolTip = function() {
          if(self.comments == null) {
            self.comments = {
              cardmemberComments: '',
              managerComments: ''
            };

            AdditionalTransactionDataRepository.findAdditionalTransactionData(self.transaction).then(function(additionalData) {
              self.comments.cardmemberComments = _.get(additionalData,'cardmemberComments');
              self.comments.managerComments = _.get(additionalData,'managerComments');
            }).catch(function() {
              self.comments = null;
            });
          }
        };
        
        self.hasCardmemberComment = function () {
          var commentIndicator = _.get(self.transaction, 'mutableTransactionProperties.commentIndicator');
          return commentIndicator == 'CARDMEMBER_COMMENT' || commentIndicator == 'BOTH';
        };
        
        self.hasCardmanagerComment = function () {
          var commentIndicator = _.get(self.transaction, 'mutableTransactionProperties.commentIndicator');
          return commentIndicator == 'MANAGER_COMMENT' || commentIndicator == 'BOTH';
        };

        self.preAuthId = function () {
          if(self.transaction.preAuthData && self.transaction.preAuthData.length > 0) {
            return _.get(self.transaction.preAuthData[0].id, 'preAuthorizationId', '');
          }
        };
        
        self.poNumber = function () {
          if(self.transaction.transactionThirdPartyData && self.transaction.transactionThirdPartyData.length > 0) {
            return _.get(self.transaction.transactionThirdPartyData[0], 'poNumber', '');
          }
        };
        
        self.toggleCheckTransaction = function (transaction, clickEvent) {
          clickEvent.stopPropagation();

          if (self.isChecked(transaction)) {
            SelectedTransactionService.removeTransaction(transaction);
          } else {
            SelectedTransactionService.addTransaction(transaction);
          }
        };

        self.accountingFieldValueFor = function accountingFieldValueFor(transaction, schema) {
          var allocations = _.get(transaction, 'allocations', []);
          if (schema === undefined || allocations.length === 0 || schema === null) {
            return '';
          }

          if (schema.position === -1) {
            return _.get(allocations[0],'description');
          } else {
            var accountingFieldValues = allocations[0].accountingFieldValues;
            var accountingFieldValue = _.find(accountingFieldValues, ['position', schema.position]);
            return _.get(accountingFieldValue, 'value', '');
          }
        };
        self.valueForGivenAccountingField = function givenAccountingFieldValueFor(transaction, position) {
          var allocations = _.get(transaction, 'allocations', []);
        if (position === -1) {
            return _.get(allocations[0],'description');
          } else {
            var accountingFieldValues = allocations[0].accountingFieldValues;
            var accountingFieldValue = _.find(accountingFieldValues, ['position', position]);
            return _.get(accountingFieldValue, 'value', '');
          }
        };
        self.displayPreAuthData = function () {
          return SiteConfigModel.isPreAuth();
        };

        self.getMerchantTooltip = function() {
          if (self.merchantInfo == null) {
            self.merchantInfo = 'not null';
            return MerchantInfoRepository.fetchMerchantInfo(self.transaction)
              .then(function(response) {
                self.merchantInfo = response;
              })
              .catch(function() {
                self.merchantInfo = null;
              });
          }
        };

        self.accountingFieldSchemasInDisplayOrder = function() {
          return _.sortBy(_.get(SiteConfigModel.siteConfig(), 'accountingFieldSchemas', []), 'displayIndex');  
        };

        self.allocationDescription = function() {
          var allocations = _.get(self.transaction, 'allocations', []);
          if (allocations.length === 0) {
            return '';
          }
          var allocation = allocations[0];
          return _.get(allocation, 'description', '');
        };

        self.getCurrencyFormat = UserModel.getCurrencyFormat;

        function hasBeenReviewed(transaction) {
          return _.get(transaction, 'mutableTransactionProperties.transactionStatus') !== 'NOT_REVIEWED';
        }

        function getExceptionNote() {
          var exceptionNote = translateExceptionNote(_.get(self.transaction, 'details.exceptionNote', ''));
          return exceptionNote;
        }

        function translateExceptionCode(exceptionCode) {
          var parsedCode = parseExceptionCode(exceptionCode);

          var translated = $translate.instant('transactions.transactionDetails.exceptionCodes.' + parsedCode.code, parsedCode.parameters);

          if (translated === 'transactions.transactionDetails.exceptionCodes.' + parsedCode.code) {
            return exceptionCode;
          } else {
            self.exceptionCodes[exceptionCode] = translated;
            return translated;
          }
        }

        function parseExceptionCode(exceptionCode) {
          var parsedString = _.split(exceptionCode, '~');
          var parsedCode = {code: '', parameters: {}};
          _.forEach(parsedString, function(s,index) {
            if (index === 0) {
              parsedCode.code = s;
            } else {
              parsedCode.parameters['param_' + index] = s;
            }
          });
          return parsedCode;
        }

        function translateExceptionNote(exceptionNote) {
          return _.join(_.map(_.split(exceptionNote,' '), function(string) {
            if (_.startsWith(string, '@')) {
              return translateExceptionCode(string);
            }
            return string;
          }), ' ');
        }
      }
    };
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/transactionRow.js
// module id = 538
// module chunks = 0